// extracted by mini-css-extract-plugin
module.exports = {"border":"_1OFJnFI0kRQLWx1Glb7eGQ","mode":"_1wQ0qBEzNpVoy1ra8iUurB","identifier":"_3ibl0Tz4aldGbCF_i0FxF7","unsubscribeButton":"_3EE5Eajg0rA7CWIURjvf_W"};